import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Navbar from './components/Navbar';
import YourFabric from './pages/YourFabric';
import Dashboard from './pages/Dashboard';
import AdminNavigator from './components/AdminNavigator';

// Health check component
const Health = () => {
  React.useEffect(() => {
    // Set response headers for JSON
    document.title = "YourFabric Health Check";
  }, []);
  
  return (
    <div style={{ 
      fontFamily: 'monospace', 
      padding: '20px',
      backgroundColor: '#f8f9fa',
      border: '1px solid #dee2e6',
      borderRadius: '4px'
    }}>
      <pre>{JSON.stringify({
        status: "healthy",
        service: "yourfabric",
        timestamp: new Date().toISOString(),
        version: "1.0.0"
      }, null, 2)}</pre>
    </div>
  );
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Navbar />
          <main className="container mx-auto px-4 py-8">
            <Routes>
              <Route path="/" element={<YourFabric />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/configurations" element={<YourFabric />} />
              <Route path="/health" element={<Health />} />
            </Routes>
          </main>
          <AdminNavigator />
        </div>
      </Router>
    </QueryClientProvider>
  );
}

export default App;